class SizeGuideDrawer extends Drawer {
  constructor() {
    super();
  }
}

class SizeGuideDrawerButton extends DrawerButton {
  constructor() {
    super();
  }
}
class SizeGuideModels extends HTMLElement {
  constructor() {
    super();

    this.buttons = this.querySelectorAll(".model-buttons button");
    this.models = this.querySelectorAll(".model");
  }

  connectedCallback() {
    if (this.buttons.length > 1) {
      this.buttons.forEach((button, index) => {
        button.addEventListener("click", () => this.handleButtonClick(index));
      });
    }
  }

  handleButtonClick(index) {
    this.buttons.forEach((button, i) => {
      if (i === index) {
        button.classList.remove("button--outline");
      } else {
        button.classList.add("button--outline");
      }
    });
    this.models.forEach((model, i) => {
      if (i === index) {
        model.classList.remove("hidden");
      } else {
        model.classList.add("hidden");
      }
    });
  }
}

customElements.define("size-guide-models", SizeGuideModels);
customElements.define("size-guide-drawer", SizeGuideDrawer);
customElements.define("size-guide-drawer-button", SizeGuideDrawerButton);
